import { createRouter, createWebHistory } from 'vue-router';
import Index from './pages/Index.vue';
import SignIn from './pages/SignIn.vue';
import SignUp from './pages/SignUp.vue';
import CustomerPanel from './pages/CustomerPanel.vue';
import { useMainStore } from '@/store';

const routes = [
    {
        "path": "/",
        "name": "home",
        "component": Index,
        "meta": { requiresAuth: true }    
    },
    {
        "path": "/customer-panel",
        "name": "customer-panel",
        "component": CustomerPanel,
        "meta": { requiresAuth: true }
    },
    {
        "path": "/sign-in",
        "name": "sign-in",
        "component": SignIn
    },
    {
        "path": "/sign-up",
        "name": "sign-up",
        "component": SignUp
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const store = useMainStore();
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !store.user) {
        next({ name: 'sign-in' });
    } else if ((to.name === 'sign-in' || to.name === 'sign-up') && store.user) {
        next({ name: 'home' });
    } else {
        next();
    }
});

export default router;